import React from "react";
import style from "./index.module.scss";
import { Tabs } from "antd";
import AccountMode, { AccountModeProps } from "./components/AccountMode";
import useDeviceType from "Utils/useDeviceType";

interface LoginComponentProps extends AccountModeProps {}

export default function LoginComponent({ ...props }: LoginComponentProps) {
    const { isMobile } = useDeviceType();

    return (
        <div className={style.root}>
            <div className={style.title}>白果云课堂</div>

            {isMobile && (
                <div className={style.mobileHead}>
                    <div>
                        <img src={require("./img/white_logo.png")} alt="logo" />
                    </div>

                    <h1 className={style.mobileTitle}>
                        东北财经大学·白果云课堂
                    </h1>

                    <p className={style.mobileSubTitle}>
                        DUFE Baiguo Cloud classroom
                    </p>

                    <p className={style.mobileSubTitle}>学生登录</p>
                </div>
            )}

            <div className={style.main}>
                <div className={style.card}>
                    <div className={style.tip}>学生登录</div>

                    <Tabs defaultActiveKey="1" className={style.tab}>
                        <Tabs.TabPane tab="账号验证" key="1">
                            <AccountMode {...props} />
                        </Tabs.TabPane>
                    </Tabs>
                </div>
            </div>
        </div>
    );
}
